// extracted by mini-css-extract-plugin
export var bodyRow = "_e8-d";
export var cardColumns = "_e8-e";
export var ellipsesOverflow = "_e8-2";
export var flatBottomCorners = "_e8-3";
export var flatTopCorners = "_e8-4";
export var headerActionsDropdown = "_e8-f";
export var headerBottomRow = "_e8-c";
export var headerTopRow = "_e8-b";
export var orderDetailsWrapper = "_e8-0";
export var orderInfoContainer = "_e8-1";
export var productDetails = "_e8-9";
export var productImage = "_e8-5";
export var responsiveTable = "_e8-8";
export var shipmentContainer = "_e8-a";
export var tableBottomLeft = "_e8-6";
export var tableBottomRight = "_e8-7";